import { HStack, VStack } from '@looko-design-system';
import { Typography } from '@mui/material';
import { convertNewlineToJSX } from '@toss/react';

import { useGetMaintenance } from '@/app/manager/maintenance-setting/hooks/useGetMaintenance';
import useGetShopInfo from '@/app/shop/shop-info/useGetShopInfo';
import useUserState from '@/hook/useUserState';
import { useShopAuth } from '@/state/userAuthContext';

import { roleManager, roleViewer } from '../consts';

const TITLE_WIDTH = '80px';
const CONTENT_WIDTH = '355px';

/**
 * 점검 페이지 가드.
 */
export function MaintenanceGuard({
  children,
  disablePassthrough = false,
}: {
  children: React.ReactNode;

  /**
   * Role 에 따른 통과 기능 비활성화 여부.
   */
  disablePassthrough?: boolean;
}) {
  const { data: maintenance } = useGetMaintenance();
  const user = useUserState();

  // XXX: 샵 선택 없어도 상관 없음.
  const shop = useShopAuth();
  const { data: shopInfo } = useGetShopInfo(shop.shopID, { enabled: !disablePassthrough && !!shop.shopID });

  const showMaintenance =
    maintenance?.isMaintenance &&
    (disablePassthrough ||
      !(user?.roles.includes(roleManager) || user?.roles.includes(roleViewer) || shopInfo?.isTest));

  if (showMaintenance) {
    return <MaintenancePage />;
  }

  return children;
}

/**
 * 점검 페이지
 */
export default function MaintenancePage() {
  const { data: maintenance } = useGetMaintenance();

  return (
    <VStack justifyContent={'center'} alignItems={'center'} height={'100vh'}>
      <VStack justifyContent={'center'} flex={1} spacing={2.5} width={487} height={'100%'}>
        <Typography fontSize={32} fontWeight={700} color="primary.main">
          Looko-AI 업데이트
        </Typography>

        <VStack p={3} spacing={2} bgcolor="grey.100">
          <HStack spacing={2.5}>
            <Typography variant="Subtitle_Looko" width={TITLE_WIDTH}>
              업데이트 내용
            </Typography>
            <Typography variant="Body_Looko" width={CONTENT_WIDTH}>
              {maintenance?.updateDetails}
            </Typography>
          </HStack>

          <HStack spacing={2.5}>
            <Typography variant="Subtitle_Looko" width={TITLE_WIDTH}>
              종료 예정시간
            </Typography>
            <Typography variant="Body_Looko" width={CONTENT_WIDTH}>
              {maintenance?.endTime}
            </Typography>
          </HStack>
        </VStack>

        <Typography variant="Subtitle_Looko">안녕하세요. 룩코입니다.</Typography>
        <Typography variant="Body_Looko">
          {convertNewlineToJSX(
            '현재 Looko-AI 시스템 업데이트가 진행중이며, 업데이트 시간 동안 솔루션 이용이 제한됩니다. 본 페이지를 확인하기 이전에 수행하신 작업들은 모두 안전하게 저장됩니다.\n\n업데이트 종료시간 이후에도 본 페이지가 나타나는 경우, 새로고침 이후 다시 실행해주시면 됩니다. 솔루션 이용에 다소 불편을 드린 점 양해 부탁드립니다.\n\n감사합니다.\n룩코팀 드림',
          )}
        </Typography>
      </VStack>
    </VStack>
  );
}
